import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Device } from "@twilio/voice-sdk";
import { BASE_URL,REACT_APP_TWILLIO_NU } from '../../constant/const.js';
import UserStore from '../../store/UserStore';

const Call = (data) => {

  const [twilioDevice, setTwilioDevice] = useState(null);
  const [connection, setConnection] = useState(null);
  const [isCalling, setIsCalling] = useState(null);
   const user_data = UserStore((state) => state.user);
   const token = user_data;
   const user_Info = UserStore((state) => state.userInfo);
   const login_user_type= user_Info.user_type;
   const login_user_email= user_Info.email;
  
   var customer_number;
   if(user_Info.user_type == "secondary_customer"){
    customer_number = user_Info.phone;
   }
   else{
    customer_number = data.customer;
   }

  useEffect(() => {
    getToken();
  }, []);

  // 1. Get Twilio Token for WebRTC
  const getToken = async () => {
    const config = {
                headers: {
                    "Content-type": "application/json",
                    "Authorization": token,
                },
            };
    try{
      const response = await axios.post(`${BASE_URL}call/token`,{
        identity: "user1",
      },config);
      const device = new Device(response.data.token, {
        codecPreferences: ["opus", "pcmu"],
        fakeLocalDTMF: true,
        enableRingingState: true,
      });
      device.on("ready", () => console.log(""));
      device.on("error", (error) => console.error("Twilio Device Error:", error));
      device.on("connectionEstablished", (conn) => {
        setConnection(true);
      });
      device.on("connectionDisconnected", () => {
        setConnection(false);
      });
      setTwilioDevice(device);
    } catch (error) {
      console.error("Error getting Twilio token:", error);
    }
  };

  // 2. Make an Outgoing Call (WebRTC to Phone)
  const makeCall = async () => {
    const config = {
                headers: {
                    "Content-type": "application/json",
                    "Authorization": token,
                },
            };
   const response = await axios.post(`${BASE_URL}call/call`, {
      //to: data.customer, // Number to call
      to:customer_number,
      vto:data.analist,
      ticketid:data.ticketid,
      login_user_type:login_user_type,
      login_user_email: login_user_email,
      from: REACT_APP_TWILLIO_NU,
    },config);
    if (response.data.success) {
      setIsCalling(true);
    } else {
      setIsCalling(false);
      alert("Call failed!");
    }
  }

  // 3. Hang Up Call
  const hangUp = () => {
    setIsCalling(false);
    if (connection) {
      connection.disconnect();
      setConnection(null);
    }
  };

  return (
    <div>
      {isCalling ? (

        <i className='fas fa-phone-slash' onClick={hangUp}></i>
      ) : (
        <i className="fa fa-phone cursor-pointer" onClick={makeCall}></i>
      )}
      <br />
    </div>
  );
};

export default Call;

